import React from "react";
import { Text } from "../../text";
import { defaultStyles } from "../../../../constants/style-constants/utils";
import Modal from "../modal";
import { Button } from "../../button";
import * as Style from "./styles/add-modal";
import { Icon } from "antd";
import { InputGroup } from "../../input/styles/input";
import {
  Input,
  InputGroupFlex,
  IconContainer,
} from "../../../styled-components/input/styles/inputTax";
import { ToolTipCreator } from "../../../../helpers/ToolTipCreator";

function IconInputTaxNew(props) {
  const {
    onChange,
    name,
    style,
    iconPosition,
    iconType,
    icon,
    placeholder,
    value,
    taxCreditData,
  } = props.value || props;

  const { index, obj } = props;
  return (
    <>
      <InputGroupFlex>
        {iconPosition === "start" ? (
          iconType ? (
            <IconContainer>
              <Icon type="phone" />
            </IconContainer>
          ) : (
            <IconContainer>
              <div>{icon}</div>
            </IconContainer>
          )
        ) : null}
        <Input
          style={style}
          disabled={taxCreditData && taxCreditData["unknownDollarValue"]}
          onChange={(event) => {
            const inputValue = event.target.value;

            // Allow only numbers with up to two decimal places
            const regex = /^\d*\.?\d{0,2}$/;

            if (regex.test(inputValue)) {
              if (obj === "nestedObj") {
                onChange(index, event.target);
              } else {
                onChange(event);
              }
            }
          }}
          name={name}
          placeholder={placeholder}
          value={value}
        />
        {/* {iconPosition === "end" ? (
          <IconContainer>
            <Icon type="phone" />
          </IconContainer>
        ) : null} */}

        {iconPosition === "end" ? (
          iconType ? (
            <IconContainer>
              <Icon type="phone" />
            </IconContainer>
          ) : (
            <IconContainer>
              <div>{icon}</div>
            </IconContainer>
          )
        ) : null}
      </InputGroupFlex>
      <div style={{ display: "flex", alignItems: "center", columnGap: "1rem" }}>
        <input
          type="checkbox"
          checked={
            taxCreditData && taxCreditData["unknownDollarValue"]
              ? taxCreditData["unknownDollarValue"]
              : false
          }
          name={"unknownDollarValue"}
          onChange={onChange}
          style={{ width: "16px", height: "16px", cursor: "pointer" }}
        />
        Dollar Value Unknown
      </div>
    </>
  );
}

function AddCreditNewModal({
  show,
  close,
  fields,
  submitData,
  modalTitle,
  obj,
  handleTaxCreditInfo,
  taxCreditData,
}) {
  const { styles } = defaultStyles;
  const handleSubmit = () => {
    submitData();
    close();
  };

  const value = {
    icon: "$",
    iconPosition: "start",
    value: taxCreditData["amountOfCredit"],
    placeholder: "Enter value..",
    name: "amountOfCredit",
    taxCreditData,
    onChange: (event) => handleTaxCreditInfo(event.target),
  };

  return (
    <Modal show={show} customWidth={true}>
      <Style.HeaderConatiner>
        <Text style={styles.text.formHeaderText}>{modalTitle}</Text>
        <Icon type="close" onClick={close}></Icon>
      </Style.HeaderConatiner>

      <Style.FieldsContainer style={{ height: "20rem" }}>
        <InputGroup style={{ width: "15rem", marginTop: "0px" }}>
          <Text
            style={{
              ...styles.text.labelText,
              display: "flex",
              alignItems: "baseline",
              columnGap: "3px",
            }}
            padding="1rem 0 0rem 0 "
          >
            Amount Of Credit <ToolTipCreator name="amount_of_credit" />
          </Text>
          <IconInputTaxNew value={value} />
        </InputGroup>
        {fields &&
          fields.map((data, index) => {
            console.log("dataaa", data);
            console.log("obj", obj);

            if (obj === "nestedObj") {
              return (
                <div style={{ display: "flex", columnGap: "2rem" }}>
                  {Object.keys(data).map((key, index1) => {
                    console.log("keyyy", data[key]);
                    const { value, Component, title, onChange, name, style } =
                      data[key];
                    return (
                      <InputGroup>
                        <Text
                          style={styles.text.labelText}
                          padding="2rem 0 0 0 "
                        >
                          {title || value.title}{" "}
                          <ToolTipCreator name={value.tooltip} />
                        </Text>

                        <Component
                          key={index}
                          value={value}
                          name={name}
                          style={{
                            ...style,
                            cursor: title === "Year" ? "not-allowed" : "",
                            pointerEvents: title === "Year" ? "none" : "",
                          }}
                          index={index}
                          obj={obj}
                          onChange={(event) => onChange(index, event.target)}
                        />
                      </InputGroup>
                    );
                  })}
                </div>
              );
            } else {
              const { value, Component, title, onChange, name, style } = data;
              return (
                <InputGroup
                  style={{
                    width: "15rem",
                    marginTop: "0px",
                    ...(value && value.name === "taxCredit"
                      ? { marginBottom: "2rem" }
                      : {}),
                  }}
                >
                  <Text
                    style={{
                      ...styles.text.labelText,
                      display: "flex",
                      alignItems: "baseline",
                      columnGap: "3px",
                    }}
                    padding="1rem 0 0rem 0 "
                  >
                    {title || value.title}{" "}
                    <ToolTipCreator name={value.tooltip} />
                  </Text>

                  <Component
                    key={index}
                    value={value}
                    name={name}
                    style={style}
                    obj={obj}
                    type={data && data.type ? data.type : ""}
                    onChange={onChange}
                  />
                </InputGroup>
              );
            }
          })}
      </Style.FieldsContainer>

      <Style.ButtonsContainer>
        <Button style={styles.button.smallButton} onClick={close}>
          Cancel
        </Button>
        <Button style={styles.button.smallButton} onClick={handleSubmit}>
          Ok
        </Button>
      </Style.ButtonsContainer>
    </Modal>
  );
}

export default AddCreditNewModal;
